import { IEditDishState } from './editDishContext';
import { EditDishActionTypes, TEditDishAction } from './editDishActions';

export const editDishReducer = (state: IEditDishState, action: TEditDishAction): IEditDishState => {
	switch (action.type) {
		case EditDishActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case EditDishActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditDishActionTypes.SET_ALL_DATA:
			return {
				...state,
				filePath: action.payload.filePath,
				preSignedUrl: action.payload.preSignedUrl,
				smallFilePath: action.payload.smallFilePath,
				smallPreSignedUrl: action.payload.smallPreSignedUrl,
				videoPath: action.payload.videoPath,
				videoPreSignedUrl: action.payload.videoPreSignedUrl,
				isVideoActive: action.payload.isVideoActive,
				dishId: action.payload.dishId,
				name: action.payload.name,
				selectedCustomer: action.payload.selectedCustomer,
				articleNumber: action.payload.articleNumber,
				restaurantsForPrice: action.payload.restaurantsForPrice,
				totalPrices: action.payload.totalPrices,
				restaurantWithTurnOffComment: action.payload.restaurantWithTurnOffComment,
				restaurantWithRequiredComment: action.payload.restaurantWithRequiredComment,
				shortDescription: action.payload.shortDescription,
				posName: action.payload.posName,
				isComboDish: action.payload.isComboDish,
				initialSelectedComboModifier: action.payload.initialSelectedComboModifier,
				initialCategories: action.payload.initialCategories,
				initialSubCategories: action.payload.initialSubCategories,
				externalId: action.payload.externalId,
				isCreatedInPos: action.payload.isCreatedInPos,
				isDisabledInRestaurants: action.payload.isDisabledInRestaurants,
				translations: action.payload.translations,
				activationSchedule: action.payload.activationSchedule,
				deactivationSchedule: action.payload.deactivationSchedule,
				initialModifierGroups: action.payload.initialModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				initialModifierGroupsAsAdditional: action.payload.initialModifierGroupsAsAdditional,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
				selectedDishModifications: action.payload.selectedDishModifications,
				IDsShowInComboDishes: action.payload.IDsShowInComboDishes,
				fetchedDishModifications: action.payload.fetchedDishModifications,
				isTaxPercentProtectedFromSync: action.payload.isTaxPercentProtectedFromSync,
				taxPercent: action.payload.taxPercent,
				hasOpenPrice: action.payload.hasOpenPrice,
				openPrice: action.payload.openPrice,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
				isFiscalized: action.payload.isFiscalized,
			};
		case EditDishActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditDishActionTypes.SET_FILE_ID:
			return {
				...state,
				fileId: action.payload.fileId,
			};
		case EditDishActionTypes.DELETE_PHOTO:
			return {
				...state,
				filePath: null,
				fileId: null,
			};
		case EditDishActionTypes.SET_SMALL_FILE_ID:
			return {
				...state,
				smallFileId: action.payload.smallFileId,
			};
		case EditDishActionTypes.DELETE_SMALL_PHOTO:
			return {
				...state,
				smallFilePath: null,
				smallFileId: null,
			};
		case EditDishActionTypes.SET_VIDEO_FILE_ID:
			return {
				...state,
				videoFileId: action.payload.videoFileId,
			};
		case EditDishActionTypes.DELETE_VIDEO:
			return {
				...state,
				videoPath: null,
				videoFileId: null,
				isVideoActive: false,
			};
		case EditDishActionTypes.SET_IS_VIDEO_ACTIVE:
			return {
				...state,
				isVideoActive: action.payload.isVideoActive,
			};
		case EditDishActionTypes.CHANGE_DISH_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case EditDishActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case EditDishActionTypes.SET_RESTAURANTS_FOR_PRICE:
			return {
				...state,
				restaurantsForPrice: action.payload.restaurantsForPrice,
			};
		case EditDishActionTypes.CHANGE_PRICE:
			return {
				...state,
				price: action.payload.price,
			};
		case EditDishActionTypes.ADD_PRICE:
			return {
				...state,
				totalPrices: [...state.totalPrices, ...action.payload.totalPrices],
				price: '',
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				modifierGroupsWithAdditionalData: [],
				selectedModifierGroupsAsAdditional: [],
				fetchedCategories: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
			};
		case EditDishActionTypes.REMOVE_PRICE:
			return {
				...state,
				totalPrices: action.payload.totalPrices,
				restaurantsForPrice: action.payload.restaurantsForPrice,
				isDisabledInRestaurants: action.payload.isDisabledInRestaurants,
				restaurantWithTurnOffComment: action.payload.restaurantWithTurnOffComment,
				restaurantWithRequiredComment: action.payload.restaurantWithRequiredComment,
				fetchedCategories: [],
				fetchedModifierGroups: [],
				selectedModifierGroups: [],
				modifierGroupsWithAdditionalData: [],
				selectedModifierGroupsAsAdditional: [],
				selectedSuggestedDishCategory: null,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
				fetchedSuggestedDishes: [],
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
				fetchedAdditionalDishes: [],
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
				fetchedDishModifications: [],
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
			};
		case EditDishActionTypes.CHANGE_DISH_DESCRIPTION:
			return {
				...state,
				shortDescription: action.payload.shortDescription,
			};
		case EditDishActionTypes.SET_RESTAURANT_WITH_TURN_OFF_COMMENT:
			return {
				...state,
				restaurantWithTurnOffComment: action.payload.restaurantWithTurnOffComment,
			};
		case EditDishActionTypes.SET_RESTAURANT_WITH_REQUIRED_COMMENT:
			return {
				...state,
				restaurantWithRequiredComment: action.payload.restaurantWithRequiredComment,
			};
		case EditDishActionTypes.SET_FETCHED_COMBO_MODIFIER:
			return {
				...state,
				fetchedComboModifier: action.payload.fetchedComboModifier,
			};
		case EditDishActionTypes.SET_ID_COMBO_MODIFIER:
			return {
				...state,
				selectedComboModifier: action.payload.selectedComboModifier,
			};
		case EditDishActionTypes.SET_DISH_IS_DISABLED:
			return {
				...state,
				isDisabledInRestaurants: action.payload.isDisabledInRestaurants,
			};
		case EditDishActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE:
			return {
				...state,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case EditDishActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case EditDishActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case EditDishActionTypes.CHANGE_ACTIVATION_SCHEDULE:
			return {
				...state,
				activationSchedule: action.payload.activationSchedule,
			};
		case EditDishActionTypes.CHANGE_DEACTIVATION_SCHEDULE:
			return {
				...state,
				deactivationSchedule: action.payload.deactivationSchedule,
			};
		case EditDishActionTypes.SET_FETCHED_MODIFIER_GROUPS:
			return {
				...state,
				fetchedModifierGroups: action.payload.fetchedModifierGroups,
			};
		case EditDishActionTypes.SET_MODIFIER_GROUPS:
			return {
				...state,
				selectedModifierGroups: action.payload.selectedModifierGroups,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
				selectedModifierGroupsAsAdditional: action.payload.selectedModifierGroupsAsAdditional,
			};
		case EditDishActionTypes.UPDATE_MODIFIER_GROUPS:
			return {
				...state,
				modifierGroupsWithAdditionalData: action.payload.modifierGroupsWithAdditionalData,
			};
		case EditDishActionTypes.SET_MODIFIER_GROUPS_AS_ADDITIONAL:
			return {
				...state,
				selectedModifierGroupsAsAdditional: action.payload.selectedModifierGroupsAsAdditional,
			};
		case EditDishActionTypes.SET_FETCHED_CATEGORIES:
			return {
				...state,
				fetchedCategories: action.payload.fetchedCategories,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISH_CATEGORY:
			return {
				...state,
				selectedSuggestedDishCategory: action.payload.selectedSuggestedDishCategory,
				fetchedSuggestedDishSubCategories: [],
				selectedSuggestedDishSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_SUGGESTED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedSuggestedDishSubCategories: action.payload.fetchedSuggestedDishSubCategories,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedSuggestedDishSubCategory: action.payload.selectedSuggestedDishSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_SUGGESTED_DISHES:
			return {
				...state,
				fetchedSuggestedDishes: action.payload.fetchedSuggestedDishes,
			};
		case EditDishActionTypes.SET_SUGGESTED_DISHES:
			return {
				...state,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		case EditDishActionTypes.REMOVE_SUGGESTED_DISH:
			return {
				...state,
				selectedSuggestedDishes: action.payload.selectedSuggestedDishes,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISH_CATEGORY:
			return {
				...state,
				selectedAdditionalDishCategory: action.payload.selectedAdditionalDishCategory,
				fetchedAdditionalDishSubCategories: [],
				selectedAdditionalDishSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedAdditionalDishSubCategories: action.payload.fetchedAdditionalDishSubCategories,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedAdditionalDishSubCategory: action.payload.selectedAdditionalDishSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_ADDITIONAL_DISHES:
			return {
				...state,
				fetchedAdditionalDishes: action.payload.fetchedAdditionalDishes,
			};
		case EditDishActionTypes.SET_ADDITIONAL_DISHES:
			return {
				...state,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		case EditDishActionTypes.REMOVE_ADDITIONAL_DISH:
			return {
				...state,
				selectedAdditionalDishes: action.payload.selectedAdditionalDishes,
			};
		case EditDishActionTypes.SET_DISH_MODIFICATION_CATEGORY:
			return {
				...state,
				selectedDishModificationCategory: action.payload.selectedDishModificationCategory,
				fetchedDishModificationSubCategories: [],
				selectedDishModificationSubCategory: null,
			};
		case EditDishActionTypes.SET_FETCHED_DISH_MODIFICATION_SUB_CATEGORIES:
			return {
				...state,
				fetchedDishModificationSubCategories: action.payload.fetchedDishModificationSubCategories,
			};
		case EditDishActionTypes.SET_DISH_MODIFICATION_SUB_CATEGORY:
			return {
				...state,
				selectedDishModificationSubCategory: action.payload.selectedDishModificationSubCategory,
			};
		case EditDishActionTypes.SET_FETCHED_DISH_MODIFICATIONS:
			return {
				...state,
				fetchedDishModifications: action.payload.fetchedDishModifications,
			};
		case EditDishActionTypes.SET_DISH_MODIFICATIONS:
			return {
				...state,
				selectedDishModifications: action.payload.selectedDishModifications,
			};
		case EditDishActionTypes.REMOVE_DISH_MODIFICATION:
			return {
				...state,
				selectedDishModifications: action.payload.selectedDishModifications,
				IDsShowInComboDishes: action.payload.IDsShowInComboDishes,
			};
		case EditDishActionTypes.SET_IDS_SHOW_IN_COMBO_DISHES:
			return {
				...state,
				IDsShowInComboDishes: action.payload.IDsShowInComboDishes,
			};
		case EditDishActionTypes.CHANGE_EXTERNAL_ID:
			return {
				...state,
				externalId: action.payload.externalId,
			};
		case EditDishActionTypes.TOGGLE_APPLICABLE_FOR_VAT:
			return {
				...state,
				isTaxPercentProtectedFromSync: action.payload.isTaxPercentProtectedFromSync,
				taxPercent: action.payload.taxPercent,
			};
		case EditDishActionTypes.CHANGE_TAX_PERCENT:
			return {
				...state,
				taxPercent: action.payload.taxPercent,
			};
		case EditDishActionTypes.TOGGLE_OPEN_PRICE:
			return {
				...state,
				hasOpenPrice: action.payload.hasOpenPrice,
				openPrice: action.payload.openPrice,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
			};
		case EditDishActionTypes.CHANGE_OPEN_PRICE:
			return {
				...state,
				openPrice: action.payload.openPrice,
			};
		case EditDishActionTypes.CHANGE_OPEN_PRICE_MAX_THRESHOLD:
			return {
				...state,
				openPriceMaxThreshold: action.payload.openPriceMaxThreshold,
			};
		case EditDishActionTypes.TOGGLE_FISCALIZED:
			return {
				...state,
				isFiscalized: !state.isFiscalized,
			};
		case EditDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditDishActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case EditDishActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				smallFileId: null,
				videoFileId: null,
				isVideoActive: false,
				name: '',
				restaurantsForPrice: [],
				price: '',
				totalPrices: [],
				restaurantWithTurnOffComment: [],
				restaurantWithRequiredComment: [],
				shortDescription: '',
				fetchedComboModifier: [],
				selectedComboModifier: null,
				isDisabledInRestaurants: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				activationSchedule: '',
				deactivationSchedule: '',
				selectedModifierGroups: [],
				modifierGroupsWithAdditionalData: [],
				selectedModifierGroupsAsAdditional: [],
				selectedSuggestedDishCategory: null,
				selectedSuggestedDishSubCategory: null,
				selectedSuggestedDishes: [],
				selectedAdditionalDishCategory: null,
				selectedAdditionalDishSubCategory: null,
				selectedAdditionalDishes: [],
				selectedDishModificationCategory: null,
				selectedDishModificationSubCategory: null,
				selectedDishModifications: [],
				IDsShowInComboDishes: {},
				externalId: state.isCreatedInPos ? state.externalId : null,
				isTaxPercentProtectedFromSync: false,
				taxPercent: null,
				hasOpenPrice: false,
				openPrice: null,
				openPriceMaxThreshold: null,
				isFiscalized: false,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
